"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatColumnModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const FormatColumnRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/FormatColumnRedux"));
const PopupRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/PopupRedux"));
const FormatColumnWizard_1 = require("../View/FormatColumn/Wizard/FormatColumnWizard");
const getScopeViewItems_1 = require("./Utilities/getScopeViewItems");
const FormatColumnFormatWizardSection_1 = require("../View/FormatColumn/Wizard/FormatColumnFormatWizardSection");
const getFormatColumnSettingsViewItems_1 = require("./Utilities/FormatColumn/getFormatColumnSettingsViewItems");
const getFormatColumnStyleViewItems_1 = require("./Utilities/FormatColumn/getFormatColumnStyleViewItems");
const getObjectTagsViewItems_1 = require("./Utilities/getObjectTagsViewItems");
const getRuleViewItems_1 = require("./Utilities/getRuleViewItems");
const MoveFormatColumn_1 = require("../View/FormatColumn/MoveFormatColumn");
const Helper_1 = require("../Utilities/Helpers/Helper");
const updateSingleToMultiplePredicates_1 = require("./Utilities/updateSingleToMultiplePredicates");
const ArrayExtensions_1 = tslib_1.__importDefault(require("../Utilities/Extensions/ArrayExtensions"));
class FormatColumnModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.FormatColumnModuleId, ModuleConstants.FormatColumnFriendlyName, 'color-palette', 'FormatColumnPopup', 'Create a column style, display format or cell alignment', api);
    }
    getModuleAdaptableObjects(config) {
        return this.api.formatColumnApi.getFormatColumns(config);
    }
    getExplicitlyReferencedColumnIds(formatColumn) {
        const queryExpression = formatColumn.Rule && this.api.expressionApi.getAdaptableQueryExpression(formatColumn.Rule);
        if (queryExpression) {
            return this.api.expressionApi.getColumnsFromExpression(queryExpression);
        }
        else if (this.api.scopeApi.scopeHasColumns(formatColumn.Scope)) {
            return this.api.scopeApi
                .getColumnsForScope(formatColumn.Scope)
                .map((adaptableColumn) => adaptableColumn.columnId);
        }
        return [];
    }
    getReferencedNamedQueryNames(formatColumn) {
        const queryExpression = formatColumn.Rule && this.api.expressionApi.getAdaptableQueryExpression(formatColumn.Rule);
        if (!queryExpression) {
            return [];
        }
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(queryExpression);
    }
    updateOldConfig() {
        this.updateFormatColumnSingleToMultiplePredicates();
        // update ConditionalStyle StatusBarPanel
        const oldStatusBars = this.api.internalApi.getState().StatusBar.StatusBars;
        let replaceConditionalStyleStatusBar = false;
        const newStatusBars = oldStatusBars.map((statusBar) => (Object.assign(Object.assign({}, statusBar), { StatusBarPanels: [
                ...new Set(statusBar.StatusBarPanels.map((statusBarPanel) => {
                    if (statusBarPanel === 'ConditionalStyle') {
                        replaceConditionalStyleStatusBar = true;
                        return 'FormatColumn';
                    }
                    return statusBarPanel;
                })),
            ] })));
        if (replaceConditionalStyleStatusBar) {
            this.api.statusBarApi.setStatusBarPanels(newStatusBars);
        }
        // update ConditionalStyle dashboard buttons
        const dashboardModuleButtons = this.api.internalApi.getState().Dashboard.ModuleButtons;
        if (dashboardModuleButtons.includes('ConditionalStyle')) {
            dashboardModuleButtons[dashboardModuleButtons.indexOf('ConditionalStyle')] = 'FormatColumn';
            const test2 = dashboardModuleButtons;
            this.api.dashboardApi.setModuleButtons([
                ...new Set(dashboardModuleButtons),
            ]);
        }
        // update ConditionalStyle toolPanel buttons
        const toolPanelModuleButtons = this.api.internalApi.getState().ToolPanel.ModuleButtons;
        if (toolPanelModuleButtons.includes('ConditionalStyle')) {
            toolPanelModuleButtons[toolPanelModuleButtons.indexOf('ConditionalStyle')] = 'FormatColumn';
            this.api.toolPanelApi.setModuleButtons([
                ...new Set(dashboardModuleButtons),
            ]);
        }
    }
    updateFormatColumnSingleToMultiplePredicates() {
        const formatColumns = this.api.formatColumnApi.getFormatColumns();
        formatColumns.forEach((formatColumn) => {
            if (formatColumn.Rule && 'Predicate' in formatColumn.Rule) {
                const preparedFormatColumn = (0, Helper_1.cloneObject)(formatColumn);
                (0, updateSingleToMultiplePredicates_1.updateSingleToMultiplePredicates)(preparedFormatColumn.Rule);
                this.api.formatColumnApi.editFormatColumn(preparedFormatColumn);
            }
        });
    }
    addColumnMenuItems(column) {
        let returnColumnMenuItems = [];
        if (column && this.isModuleEditable() && !column.isSparkline) {
            let createPopupParam = {
                column: column,
                action: 'New',
                source: 'ColumnMenu',
            };
            const createFormatColumnMenuItem = this.createColumnMenuItemShowPopup('Create', this.moduleInfo.Popup, 'plus', createPopupParam);
            const formatColumnsForColumn = this.api.formatColumnApi.getFormatColumnsForColumnId(column.columnId);
            //  .filter((fc) => this.api.scopeApi.isSingleColumnScope(fc.Scope));
            // if no formats then just show Create
            if (ArrayExtensions_1.default.IsNullOrEmpty(formatColumnsForColumn)) {
                returnColumnMenuItems.push(this.createColumnMenuItemShowPopup('Create Format Column', this.moduleInfo.Popup, this.moduleInfo.Glyph, createPopupParam));
                // if 1 format then show a Create and an Edit
            }
            else if (formatColumnsForColumn.length == 1) {
                let editPopupParam = {
                    column: column,
                    action: 'Edit',
                    value: formatColumnsForColumn[0],
                    source: 'ColumnMenu',
                };
                const editFormatColumnMenuItem = this.createColumnMenuItemShowPopup('Edit', this.moduleInfo.Popup, 'edit', editPopupParam);
                returnColumnMenuItems.push({
                    label: 'Format Column',
                    module: this.moduleInfo.ModuleName,
                    isVisible: true,
                    icon: { name: this.moduleInfo.Glyph },
                    subItems: [createFormatColumnMenuItem, editFormatColumnMenuItem],
                });
                // if more than one then display a Create and a Show
                // we should probably do the Show better - perhaps use Column Info in some way?
                // or to filter the format columns ?
            }
            else {
                const moduleInfo = this.api.internalApi
                    .getModuleService()
                    .getModuleInfoByModule('FormatColumn');
                const editFormatColumnMenuItem = this.createColumnMenuItemReduxAction('Show Current', this.moduleInfo.Glyph, PopupRedux.PopupShowScreen('FormatColumn', moduleInfo.Popup));
                returnColumnMenuItems.push({
                    label: 'Format Column',
                    module: this.moduleInfo.ModuleName,
                    isVisible: true,
                    icon: { name: this.moduleInfo.Glyph },
                    subItems: [createFormatColumnMenuItem, editFormatColumnMenuItem],
                });
            }
        }
        return returnColumnMenuItems;
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.formatColumnApi.getFormatColumns(),
            AddAction: FormatColumnRedux.FormatColumnAdd,
            EditAction: FormatColumnRedux.FormatColumnEdit,
        };
    }
    toView(formatColumn) {
        return {
            abObject: formatColumn,
            items: [
                (0, getScopeViewItems_1.getScopeViewItems)(formatColumn.Scope, this.api),
                formatColumn.Rule && (0, getRuleViewItems_1.getRuleViewItems)(formatColumn.Rule, this.api),
                {
                    name: 'Style',
                    view: () => (0, getFormatColumnStyleViewItems_1.getFormatColumnStyleViewItems)(formatColumn, this.api),
                },
                {
                    name: 'Display Format',
                    values: [(0, FormatColumnFormatWizardSection_1.getFormatColumnFormatSummaryValue)(formatColumn)],
                },
                (0, getFormatColumnSettingsViewItems_1.getFormatColumnSettingsViewItems)(formatColumn),
                (0, getObjectTagsViewItems_1.getObjectTagsViewItems)(formatColumn, this.api),
            ].filter(Boolean),
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotAssociatedObjects: this.showLayoutNotAssociatedObjects(),
        }).map((formatColumn) => this.toView(formatColumn));
    }
    getViewProperties() {
        return {
            actions: [MoveFormatColumn_1.MoveFormatColumn],
            getEditAction: FormatColumnRedux.FormatColumnEdit,
            getDeleteAction: FormatColumnRedux.FormatColumnDelete,
            getSuspendAction: FormatColumnRedux.FormatColumnSuspend,
            getUnSuspendAction: FormatColumnRedux.FormatColumnUnSuspend,
            getSuspendAllAction: FormatColumnRedux.FormatColumnSuspendAll,
            getUnSuspendAllAction: FormatColumnRedux.FormatColumnUnSuspendAll,
            getEditWizard() {
                return FormatColumnWizard_1.FormatColumnWizard;
            },
        };
    }
    canBeAssociatedWithLayouts() {
        return true;
    }
}
exports.FormatColumnModule = FormatColumnModule;
